import { render } from "./ViewPagePosts.vue?vue&type=template&id=18fb2ed8&scoped=true"
import script from "./ViewPagePosts.vue?vue&type=script&lang=js"
export * from "./ViewPagePosts.vue?vue&type=script&lang=js"

import "./ViewPagePosts.vue?vue&type=style&index=0&id=18fb2ed8&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fb2ed8"]])

export default __exports__